import React from 'react';
import PropTypes from 'prop-types';
import { componentText } from '../utils/i18n_utils';

const t = (key, fallback) => componentText(`events_list.${key}`, fallback);

const titleMessage = () => t('no_tournaments_title', 'No tournaments in this round');

const notReleasedMessage = () =>
  t('results_not_released', 'Tournament results are being reviewed and have not yet been released.');

const bodyMessage = () => t('no_tournaments_body', 'Try switching to a different round to see the leaderboard.');

const selectRoundLabel = () => t('select_different_round', 'Select a Different Round');

// Empty leaderboard state (Figma 21095-26460 web, 21095-26321 mobile,
// 21095-26285 landscape). The switch-round hint and the modal-opening button
// only make sense on multi-round pages; single-round pages get the headline
// alone. Web never gets the button - its round selector is in the top bar.
//
// resultsNotReleased marks the other empty state: the page booted with no
// round at all because every round is hidden from the portal (not started or
// results not released). It shows the legacy widget's "being reviewed"
// message as a bare headline - there is no round to switch to.
const EmptyState = ({ isMultiRound = false, onSelectRound = null, resultsNotReleased = false }) => (
  <div className="lbv2__empty-state">
    <div className="lbv2__empty-state-text">
      <h2 className="lbv2__empty-state-title">
        {resultsNotReleased ? notReleasedMessage() : titleMessage()}
      </h2>
      {!resultsNotReleased && isMultiRound && <p className="lbv2__empty-state-body">{bodyMessage()}</p>}
    </div>
    {!resultsNotReleased && isMultiRound && onSelectRound && (
      <button type="button" className="lbv2__select-round-btn" onClick={onSelectRound}>
        {selectRoundLabel()}
      </button>
    )}
  </div>
);

EmptyState.propTypes = {
  isMultiRound: PropTypes.bool,
  onSelectRound: PropTypes.func,
  resultsNotReleased: PropTypes.bool,
};

export default EmptyState;
